import "./CategoryInfo.scss";
import data from "../../data/example-category-data.json";
import { CategoryFlyouts } from "./CategoryFlyouts";
import { motion } from "framer-motion";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import { useRef, useEffect } from "react";
import { useLocation, useRoute, useRouter } from "wouter";
import { Helmet } from "react-helmet-async";
import { pageView } from "../../utils/analytics";

export function CategoryInfo({ activeCategory }) {
	const containerRef = useRef();
	const { base } = useRouter();
	const [location, updateLocation] = useLocation();
	let back = "/" + location.split("/")[1];
	let category = data.find((d) => d.slug === activeCategory);
	let [match, params] = useRoute("/tech-radar/category/:slug");
	useEffect(() => {
		if (location && category && match) {
			pageView(
				`${base}${location}`,
				`${category.title} - The Virtual Economy Technology Radar | L'Atelier`
			);
		}
	}, [location, category, match, base]);
	const shouldAllowTouchMove = (el) => {
		while (el && el !== document.body) {
			if (el.dataset["body-scroll-lock-ignore"] !== null) {
				return true;
			}

			el = el.parentElement;
		}
	};

	useEffect(() => {
		document.documentElement.classList.add("modal-active");
		disableBodyScroll(containerRef.current, {
			allowTouchMove: shouldAllowTouchMove,
		});
		return () => {
			clearAllBodyScrollLocks();
			document.documentElement.classList.remove("modal-active");
		};
	}, [containerRef]);

	useEffect(() => {
		let cb = (e) => {
			if (e.code === "Escape" && !e.metaKey) {
				updateLocation(back);
			}
		};
		window.addEventListener("keyup", cb);
		return () => {
			window.removeEventListener("keyup", cb);
		};
	}, [back, updateLocation]);

	return (
		<>
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0 }}
				transition={{ duration: 0.3 }}
				className={"category-info-bg"}></motion.div>
			<div
				className="category-info"
				ref={containerRef}
				onClick={(e) => {
					if (e.target && e.target.classList.contains("category-info")) {
						updateLocation(back);
					}
				}}>
				<Helmet>
					{category ? (
						<title>
							{category.title} - The Virtual Economy Technology Radar |
							L'Atelier
						</title>
					) : null}
				</Helmet>
				<motion.div
					initial={{ transform: "translateY(100%)" }}
					animate={{ transform: "translateY(0%)" }}
					exit={{ transform: "translateY(100%)" }}
					transition={{ duration: 0.3 }}
					className={"category-info__container"}>
					<CategoryFlyouts category={category} />
				</motion.div>
			</div>
		</>
	);
}
